import memoizeOne from 'memoize-one';

/** Checks if shared workers are supported */
export const getUseSharedWorker = memoizeOne(async (): Promise<boolean> => {
  return 'SharedWorker' in window;
});
